import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InitialInterviewPage } from '../../../enums';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  private activePageSubject = new BehaviorSubject<InitialInterviewPage>(null);
  activePage$ = this.activePageSubject.asObservable();

  setActivePage(page: InitialInterviewPage) {
    this.activePageSubject.next(page);
  }

  getActivePage() {
    return this.activePageSubject.getValue();
  }
}
